"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = Toggle;
const jsx_runtime_1 = require("react/jsx-runtime");
function Toggle({ value, onValueChange, options, ariaLabel, disabled = false, className = '', }) {
    const optionKeys = Object.keys(options);
    if (optionKeys.length !== 2) {
        throw new Error('Toggle component requires exactly 2 options');
    }
    const [leftKey, rightKey] = optionKeys;
    const checked = value === rightKey;
    const handleToggle = () => {
        if (!disabled) {
            const newValue = checked ? leftKey : rightKey;
            onValueChange(newValue);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: `flex items-center gap-2 ${className}`, children: [(0, jsx_runtime_1.jsx)("span", { className: `text-sm font-medium ${!checked ? 'text-gray-700' : 'text-gray-400'}`, children: options[leftKey] }), (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handleToggle, disabled: disabled, className: `
          relative inline-flex h-8 w-16 items-center rounded-full transition-colors
          ${checked ? 'bg-primary' : 'bg-gray-300'}
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `, "aria-label": ariaLabel, "aria-checked": checked, role: "switch", children: (0, jsx_runtime_1.jsx)("span", { className: `
            inline-block h-6 w-6 transform rounded-full bg-white transition-transform
            ${checked ? 'translate-x-9' : 'translate-x-1'}
          ` }) }), (0, jsx_runtime_1.jsx)("div", { className: "flex items-center gap-1", children: (0, jsx_runtime_1.jsx)("span", { className: `text-sm font-medium ${checked ? 'text-gray-700' : 'text-gray-400'}`, children: options[rightKey] }) })] }));
}
